import User from "@/shared/models/User";
import UploadedPlatformDocumentMetadata from "@/features/PlatformDocuments/UploadedPlatformDocumentMetadata";
import PlatformDocumentMetadata from "@/features/PlatformDocuments/PlatformDocumentMetadata";

// WARNING: this enum is synced with Server side code in Action Data model
export enum ActionStatus {
    Pending,
    Acknowledged,
    Completed,
}

export enum UIActionStatus {
    // MUST match the above ActionStatus, this is for displaying human readable values in the UI
    Pending = "Pending",
    Acknowledged = "Acknowledged",
    Completed = "Completed",
}

// WARNING: this enum is synced with Server side code in Action Data model
export enum ActionType {
    Action,
    ObsolescenceProductReviewAction,
    QualificationRequestAction,
    RequestAction,
    SupplierEventAction,
    ComplianceIncidentAction,
}

export enum UIActionType {
    // MUST match the above ActionType, this is for displaying human readable values in the UI
    Action = "General",
    ObsolescenceProductReviewAction = "Obsolescence Product Review",
    QualificationRequestAction = "Qualification Request",
    RequestAction = "Request",
    SupplierEventAction = "Supplier Event",
    ComplianceIncidentAction = "Compliance Incident",
}

export class ListAction {
    id: string | null = null;
    description: string = "";
    createdTimestampUTC: Date = new Date();
    createdByUserID: string = "";
    status: ActionStatus = null!;
    actionType: ActionType = null!;
    platformDocumentMetadataIDs: string[] = [];
    platformDocumentMetadatas: PlatformDocumentMetadata[] = [];
    uploadedPlatformDocumentMetadatas: UploadedPlatformDocumentMetadata[] = [];
    userIDs: string[] = [];
    users: ActionUser[] = [];
}

export class ListIncidentAction extends ListAction {
    incidentID: string | null = null;
}

export class ActionUser {
    id: string = "";
    name: string = "";
    email: string = "";
}

export default class Action {
    id: string | null = null;
    userIDs: string[] = [];
    users: User[] = [];
    status: ActionStatus = null!;
    actionType: ActionType = null!;
    createdTimestampUTC: Date = new Date();
    acknowlegedTimestampUTC: Date = new Date();
    completedTimestampUTC: Date = new Date();
    description: string = "";
    createdByUserID: string = "";
    createdByUser: User = new User();
    platformDocumentMetadataIDs: string[] = [];
    platformDocumentMetadatas: PlatformDocumentMetadata[] = [];
    uploadedPlatformDocumentMetadatas: UploadedPlatformDocumentMetadata[] = [];
}

export class IncidentAction extends Action {
    incidentID: string | null = null;
}
